import { cn } from '@/lib/cn';

interface SectionProps {
  children: React.ReactNode;
  background?: 'bone' | 'paper' | 'bark';
  spacing?: 'tight' | 'default' | 'loose';
  className?: string;
  id?: string;
  ariaLabel?: string;
}

const backgroundMap = {
  bone: 'bg-bone text-bark',
  paper: 'bg-paper text-bark',
  bark: 'bg-bark text-paper',
};

const spacingMap = {
  tight: 'py-12 sm:py-16',
  default: 'py-16 sm:py-24',
  loose: 'py-24 sm:py-32',
};

export function Section({
  children,
  background = 'bone',
  spacing = 'default',
  className,
  id,
  ariaLabel,
}: SectionProps): React.ReactNode {
  return (
    <section
      id={id}
      aria-label={ariaLabel}
      className={cn(backgroundMap[background], spacingMap[spacing], className)}
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-8">{children}</div>
    </section>
  );
}
